import React, { Component } from 'react';

import './template.css'
import i18n from '../../i18n';

export default class Footer extends Component {

	constructor(props) {
		super(props);
	}


	render() {
		return (
			<React.Fragment>
				<br /><br /><br /><br /><br />
				<div id="footer">
					<br />
					<footer>
						<div className="container">
							<div className="row justify-content-center">
								<div className="col">
									<p className="text-center rights">{document.getElementById("version").getAttribute("value")} © Financijska agencija, Ulica grada Vukovara 70, 10000 Zagreb, Republika Hrvatska</p>
									<p className="text-center">{i18n.t("home:info_contact")}</p>
								</div>
							</div>
						</div>
					</footer>
				</div>
			</React.Fragment>
		)
	}
}